module.exports = __webpack_public_path__ + "static/media/flaskLogo.b5348d5a.png";